export default __webpack_public_path__ + "static/media/logo-example-06.5f45a1dc.jpg";